import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const useCtaText = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return t('uploadImage.createDesigns');
};
